import React from 'react';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { redirectWithSavingScroll } from 'swag-client-common/utils/tricks';
import classes from './check-out-our-work.scss';
const CheckOutOurWork = () => /*#__PURE__*/React.createElement("div", {
  className: classes.container
}, /*#__PURE__*/React.createElement("button", {
  className: classes.button,
  onClick: redirectWithSavingScroll(APP_ROUTES.PAST_WORK)
}, "Check Out Our Work"));
export default CheckOutOurWork;